import React, { useState } from 'react';

interface NDFilterSelectorProps {
  onComplete: (filters: string[]) => void;
  onBack: () => void;
  isLoading: boolean;
}

const NDFilterSelector: React.FC<NDFilterSelectorProps> = ({ onComplete, onBack, isLoading }) => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [hasFilters, setHasFilters] = useState<boolean | null>(null);

  const availableFilters = [
    'ND4 (2-stop)',
    'ND8 (3-stop)', 
    'ND16 (4-stop)',
    'ND32 (5-stop)',
    'ND64 (6-stop)',
    'ND128 (7-stop)',
    'ND256 (8-stop)',
    'ND512 (9-stop)',
    'ND1000 (10-stop)',
    'Variable ND (2-8 stop)',
    'Variable ND (6-9 stop)',
    'Polarizing Filter'
  ];

  const handleFilterToggle = (filter: string) => {
    setSelectedFilters(prev => 
      prev.includes(filter)
        ? prev.filter(f => f !== filter)
        : [...prev, filter]
    );
  };

  const handleSubmit = () => {
    onComplete(hasFilters ? selectedFilters : []);
  };

  const handleHasFiltersChange = (hasND: boolean) => {
    setHasFilters(hasND);
    if (!hasND) {
      setSelectedFilters([]);
    }
  };

  return (
    <div className="nd-filter-selector">
      <h3>Do you have ND (Neutral Density) filters available?</h3>
      
      <div className="filter-availability">
        <button
          onClick={() => handleHasFiltersChange(true)}
          className={`option-button ${hasFilters === true ? 'selected' : ''}`}
          disabled={isLoading}
        >
          Yes, I have ND filters
        </button>
        <button
          onClick={() => handleHasFiltersChange(false)}
          className={`option-button ${hasFilters === false ? 'selected' : ''}`}
          disabled={isLoading}
        >
          No, I don't have ND filters
        </button>
      </div>

      {hasFilters === true && (
        <div className="filter-selection">
          <h4>Select all ND filters you have available:</h4>
          <div className="filter-grid">
            {availableFilters.map((filter) => (
              <button
                key={filter}
                onClick={() => handleFilterToggle(filter)}
                className={`filter-option ${selectedFilters.includes(filter) ? 'selected' : ''}`}
                disabled={isLoading}
              >
                {filter}
              </button>
            ))}
          </div>
          <p className="helper-text">
            Select all that apply. ND filters help control exposure in bright conditions and enable creative effects like motion blur.
          </p>
        </div>
      )}

      {hasFilters !== null && (
        <div className="button-group">
          <button type="button" onClick={onBack} disabled={isLoading}>
            Back
          </button>
          <button onClick={handleSubmit} disabled={isLoading}>
            Get Recommendations
          </button>
        </div>
      )}
    </div>
  );
};

export default NDFilterSelector;